module.exports = __webpack_public_path__ + "static/img/robot.0fa3227d.png";